import { render, staticRenderFns } from "./CheckZonaVincolo.vue?vue&type=template&id=89ea7970&scoped=true"
import script from "./CheckZonaVincolo.vue?vue&type=script&lang=ts"
export * from "./CheckZonaVincolo.vue?vue&type=script&lang=ts"
import style0 from "./CheckZonaVincolo.vue?vue&type=style&index=0&id=89ea7970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ea7970",
  null
  
)

export default component.exports